export type ObjectId = string;

export enum Status {
  PENDING = "PENDING",
  DONE = "DONE",
  ERROR = "ERROR",
  ABORTED = "ABORTED",
  IN_PROGRESS = "IN_PROGRESS",
  FINALIZE = "FINALIZE",
}

export enum UserRoleName {
  USER = "Utilisateur",
  ADMIN = "Administrateur",
}

export enum RoleName {
  USER = "Utilisateur",
  CONTRIBUTOR = "Contributeur",
  MANAGER = "Manageur",
}

export enum Subscription {
  PLATFORM = "PLATFORM",
  ORION = "ORION",
  SIRIUS = "SIRIUS",
}

export interface UserRole {
  role: RoleName;
  subscription: Subscription;
}
export interface UserRoles {
  role: UserRoleName;
  workspaces: Record<string, UserRole>;
}

export interface PostRequest {
  workspace_id: string | null;
}

export type ExportFormat = "csv" | "json" | "xlsx";
